module.exports = __webpack_public_path__ + "static/img/son11_active.547423d9.png";